import script from "./UserStackWithNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStackWithNotifications.vue?vue&type=script&setup=true&lang=js"

import "./UserStackWithNotifications.vue?vue&type=style&index=0&id=1ac8734d&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ac8734d"]])

export default __exports__